import * as React from 'react';
import {FunctionComponent} from 'react';
import {Block} from '../../models/Block';
import {classNames} from '../../../../components/support/classnames';

interface OwnProps {
    block: Block;
    onChange: (block: Block) => void;
}

export const RepetitionControls: FunctionComponent<OwnProps> = ({block, onChange}) => {
    return (
        <div className="block__repetitions">
            <button
                className={classNames(
                    {'block__repetitions-btn--disabled': block.repeats <= 1},
                    'block__repetitions-btn',
                    'ion-md-remove-circle',
                )}
                disabled={block.repeats <= 1}
                onClick={() => {
                    onChange({...block, repeats: block.repeats > 1 ? block.repeats - 1 : block.repeats});
                }}
            />
            {block.repeats}x
            <button
                className="block__repetitions-btn ion-md-add-circle"
                onClick={() => {
                    onChange({...block, repeats: block.repeats + 1});
                }}
            />
        </div>
    );
};
